module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-box-image-df3c9b76bbdbf462a21287c4e5bd955f.png";